import classnames from 'classnames';
import { noop } from 'lodash';
import React, { useLayoutEffect, useRef, useState } from 'react';
import Loader from '../Loader';
import styles from './Button.module.css';

export type ButtonProps = {
  children?: React.ReactNode;
  className?: string;
  linkClassName?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent) => void;
  href?: string;
  disabled?: boolean;
  target?: string;
  isLoading?: boolean;
  isWide?: boolean;
};

const Button: React.FC<ButtonProps> = props => {
  const {
    linkClassName,
    className,
    onClick = noop,
    href,
    children,
    target,
    disabled,
    isLoading,
    isWide = false,
  } = props;

  const isDisabled = disabled || isLoading;
  const ref = useRef<HTMLButtonElement>(null);
  const [buttonColor, setButtonColor] = useState('#000');

  useLayoutEffect(() => {
    if (ref.current == null) return;
    const buttonStyle = window.getComputedStyle(ref.current);
    setButtonColor(buttonStyle.color);
  }, []);

  const linkStyles = classnames(linkClassName, styles.linkStyles, {
    [styles.wideLink!]: isWide,
  });
  const buttonStyles = classnames(className, styles.button, {
    [styles.isLoading!]: isLoading,
    [styles.disabled!]: disabled,
  });

  const handleClick = function (e: React.MouseEvent<HTMLButtonElement>) {
    if (isDisabled) return;
    if (typeof onClick === 'function') onClick.call(this, e);
  };

  const submitOnEnter = (e: React.KeyboardEvent) => {
    if (isDisabled) return;
    if (e.code === 'Enter') onClick(e);
  };

  return (
    <a href={href} target={target} className={linkStyles}>
      <button
        ref={ref}
        disabled={isDisabled}
        className={buttonStyles}
        onClick={handleClick}
        type="submit"
        onKeyDown={submitOnEnter}
        tabIndex={0}
      >
        {isLoading ? <Loader customColor={buttonColor} fadeAnimation={'true'} /> : children}
      </button>
    </a>
  );
};

export default Button;
